import { loginActions } from 'primary-components';

import { routing } from 'routing';

export const getPathByAccess = component => dispatch => {
  const isIframe = window !== window.parent

  if(isIframe && component !== routing.insight.name) {
    return undefined;
  }
  if(dispatch(loginActions.hasAccessTo(component))) {
    return component;
  }
}